module.exports = __webpack_public_path__ + "static/media/celeb.d273aea4.svg";